import { adminRepositories } from "data/admin/repositories";

export const supportRequestsRepo = {
  list(params) {
    return adminRepositories.supportRequests.list(params);
  },

  getById(id) {
    return adminRepositories.supportRequests.getById(id);
  },

  create(input) {
    return adminRepositories.supportRequests.create(input);
  },

  updateStatus(id, status) {
    return adminRepositories.supportRequests.updateStatus(id, status);
  },
};
